import styled, { css } from 'styled-components';
import { COMMON, LAYOUT } from '../constants';
import { offset } from './utils/offset';
const COLUMN_RULES = css(["", ";", ";", ";min-height:1px;"], COMMON, LAYOUT, offset);
const Column = styled.div.withConfig({
  displayName: "Column",
  componentId: "lrquva-0"
})(["", ";"], COLUMN_RULES);
Column.defaultProps = {
  px: 3
};
Column.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes
};
Column.displayName = 'Column'; // Column.auto fills up the remaning space of your Row

Column.auto = styled.div.withConfig({
  displayName: "Column__auto",
  componentId: "lrquva-1"
})(["", ";"], COLUMN_RULES);
Column.auto.defaultProps = { ...Column.defaultProps,
  flex: '1 1 auto'
};
Column.auto.propTypes = Column.propTypes;
Column.auto.displayName = 'Column.auto';
export default Column;